import React from 'react';
import { Select } from 'antd';
import { setGetSortRows } from '../../../common/FilterComponent'

const sortColumnHeaderData = [{ id: 'alertDate', name: 'Alert Generation Date' },{ id: 'alertScore', name: 'Alert Score' }];
const sortAlertDate = [{ id: 'DESC', name: 'Newest To Oldest' }, { id: 'ASC', name: 'Oldest To Newest' }];
const sortAlertScore = [{ id: 'ASC', name: 'Ascending' }, { id: 'DESC', name: 'Descending' }];

export const sortColumnProps = [
    {
        title: 'Column Header',
        width: '10em',
        render: (args) => columnHeaderTemplate(args)
    }, {
        title: 'Sort By',
        width: '10em',
        render: (args) => sortByTemplate(args),
    }];


const sortByTemplate = (dataObj) => {

    const { dataList } = dataObj

    const handleChange = (dataObj) => (value) => {
        let newData = JSON.parse(JSON.stringify(setGetSortRows()()));
        const itemIndex = newData?.findIndex(({ key }) => key === dataObj?.key)
        newData[itemIndex].defaultValue = value;
        setGetSortRows(newData)
    }

    return <Select defaultValue={dataObj?.defaultValue} onChange={handleChange(dataObj)} style={{minWidth:'150px'}} >
        {dataList?.map(({ name, id }) => <Option value={id}>{name}</Option>)}
    </Select>
}

const columnHeaderTemplate = (dataObj) => {
    
    const handleChangeColHeader = (dataObj) => (value) => {
        let newData = JSON.parse(JSON.stringify(setGetSortRows()()));
        const itemIndex = newData?.findIndex(({ key }) => key === dataObj?.key)
        newData[itemIndex].id = value;

        switch (value) {
            case 'alertDate':
                newData[itemIndex].defaultValue = 'ASC'
                newData[itemIndex].dataList = sortAlertDate;
                break;
            case 'alertScore':
                newData[itemIndex].defaultValue = 'ASC'
                newData[itemIndex].dataList = sortAlertScore
            default:
                break;
        }
        setGetSortRows(newData)
    }

    return <Select defaultValue={ dataObj?.id } onChange={handleChangeColHeader(dataObj)} style={{minWidth:'200px'}}>
        {sortColumnHeaderData?.map(({ name, id }) => <Option value={id}>{name}</Option>)}
    </Select>
}

export const sortDataProps = [{
    key: '0',
    id: 'alertDate',
    label: 'Alert Generation Date',
    dataList: sortAlertDate,
    defaultValue: "ASC"
   }
];